module.exports = __webpack_public_path__ + "img/left-speech-bubble.489bd8e7.png";